"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteModel = void 0;
const SvcBillingAutomationError_1 = require("../Error/SvcBillingAutomationError");
const Quote_1 = require("./Quote");
class QuoteModel {
    constructor(props) {
        this.payload = props;
        this.id = props.id;
        this.organisation = props.organisation;
    }
    toJSON() {
        return this.payload;
    }
    static fromJSON(props, validatorOptions) {
        this.isQuoteModelType(props, validatorOptions);
        return new QuoteModel(props);
    }
    static isQuoteModelType(obj, options) {
        const errors = new Quote_1.Quote(obj).validate(options);
        if (errors.length) {
            throw new SvcBillingAutomationError_1.SvcBillingAutomationError(errors.map((error) => error.toString().trim()).join('.\n'));
        }
    }
}
exports.QuoteModel = QuoteModel;
//# sourceMappingURL=QuoteModel.js.map